module.exports = __webpack_public_path__ + "static/img/wealth_on.7f8872b6.png";